(() => {
  const HASH = '#how-it-works';
  const TARGET_ID = 'how-it-works';

  const normalisePath = (path) => {
    const cleaned = path.replace(/\/+$/, '');
    return cleaned || '/';
  };

  const rootUrl = () => {
    const configured = document.body?.dataset.mdryRootUrl || '/';
    return new URL(configured, window.location.origin);
  };

  const isHowItWorksLink = (link) => {
    const text = (link.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
    let url;

    try {
      url = new URL(link.href, window.location.href);
    } catch (_error) {
      return false;
    }

    return (
      text === 'how it works' ||
      url.hash.toLowerCase() === HASH ||
      /\/pages\/how-it-works\/?$/i.test(url.pathname)
    );
  };

  const closeMobileDrawer = () => {
    document.querySelectorAll('header-drawer').forEach((drawer) => {
      if (typeof drawer.close === 'function') drawer.close();
    });
  };

  const scrollToSection = (smooth = true) => {
    const target = document.getElementById(TARGET_ID);
    if (!target) return false;

    const header = document.getElementById('header-group');
    const headerOffset = (header?.getBoundingClientRect().height || 0) + 16;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerOffset);

    window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
    return true;
  };

  const setCorrectLinkDestinations = () => {
    const destination = `${rootUrl().pathname}${HASH}`;
    document.querySelectorAll('a[href]').forEach((link) => {
      if (isHowItWorksLink(link)) link.setAttribute('href', destination);
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('a[href]');
      if (!link || !isHowItWorksLink(link)) return;

      event.preventDefault();
      closeMobileDrawer();

      const root = rootUrl();
      const onHomepage =
        window.location.origin === root.origin &&
        normalisePath(window.location.pathname) === normalisePath(root.pathname);

      if (onHomepage && scrollToSection(true)) {
        window.history.pushState(null, '', HASH);
        return;
      }

      window.location.assign(`${root.pathname}${HASH}`);
    },
    true
  );

  const initialise = () => {
    setCorrectLinkDestinations();

    if (window.location.hash.toLowerCase() === HASH) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => scrollToSection(false));
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  window.addEventListener('load', () => {
    if (window.location.hash.toLowerCase() === HASH) scrollToSection(false);
  });

  window.addEventListener('pageshow', setCorrectLinkDestinations);
  document.addEventListener('shopify:section:load', setCorrectLinkDestinations);
})();
